module.exports = __webpack_public_path__ + "static/media/logo_header_indicadores.5bbf88f2.svg";